import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import HeadingPointerIcon from '../../../../../assets/Icons/HeadingPointerIcon';

interface ContentProps {
  heading: string;
  isReview?: boolean;
  className?: string;
}

const Headings: React.FC<ContentProps> = ({
  heading,
  isReview = false,
  className,
}) => {
  return (
    <div
      className={twMerge(
        clsx(isReview ? '' : 'mb-5', 'flex gap-x-3  items-center'),
        className,
      )}
    >
      <HeadingPointerIcon />
      <h2 className='font-bold text-lg uppercase'>{heading}</h2>
    </div>
  );
};

export default Headings;
